import { render, staticRenderFns } from "./CommonWangeditor.vue?vue&type=template&id=e6153d78&scoped=true&"
import script from "./CommonWangeditor.vue?vue&type=script&lang=js&"
export * from "./CommonWangeditor.vue?vue&type=script&lang=js&"
import style0 from "./CommonWangeditor.vue?vue&type=style&index=0&id=e6153d78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6153d78",
  null
  
)

export default component.exports